import { getTokenFromCookies, url } from "../utils/configData";
// const url = `http://192.168.0.103:8000/api`;
const fetchDeleteWallet = async (key, wallet) => {
  const end = `/wallets/${wallet}/${key}/delete`;


  const token = getTokenFromCookies();

  const headers = {
    "Content-Type": "application/json",
    // Додаємо токен до заголовків, якщо він присутній
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      return { key: key, success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Не вдалося отримати дані користувача:", error);
  }
};

export { fetchDeleteWallet };
